import { io, type Socket } from 'socket.io-client';

import { env } from './env';

let socket: Socket | null = null;

export function connectSocket(token: string): Socket {
  if (socket?.connected) return socket;
  if (socket) {
    socket.auth = { token };
    socket.connect();
    return socket;
  }

  // En dev sans VITE_WS_URL : on tape l'API directement (le proxy Vite ne gère pas WS de namespace).
  const wsUrl =
    env.wsUrl ||
    (typeof window !== 'undefined' ? window.location.origin.replace(/:\d+$/, ':4000') : '');

  socket = io(`${wsUrl}/realtime`, {
    path: '/api/realtime',
    auth: { token },
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    autoConnect: true,
    withCredentials: true,
  });

  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}

export function getSocket(): Socket | null {
  return socket;
}
